<template>
	<div class="answer-list">
		<!-- ===== Visit / outlet header ===== -->
		<div class="ad-card ad-header">
			<div class="ad-header__top">
				<span class="ad-store-icon">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16l1 5a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0z"/><path d="M5 11.5V20h14v-8.5"/><path d="M10 20v-5h4v5"/></svg>
				</span>
				<div class="ad-header__title">
					<h2 v-if="visits.outlet">{{ visits.outlet.name }}</h2>
					<span class="ad-turn-badge" v-if="visits.visit_turn">نوبت {{ visits.visit_turn }}</span>
				</div>
			</div>

			<div class="ad-info-grid" v-if="visits.outlet">
				<div class="ad-info">
					<span class="ad-info__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/></svg></span>
					<span class="ad-info__body"><span class="ad-info__lbl">آدرس مشتری</span><span class="ad-info__val">{{ visits.outlet.address }}</span></span>
				</div>
				<div class="ad-info">
					<span class="ad-info__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-7-7A2 2 0 0 1 3 12.2V5a2 2 0 0 1 2-2h7.2a2 2 0 0 1 1.4.6l7 7a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg></span>
					<span class="ad-info__body"><span class="ad-info__lbl">کد مشتری</span><span class="ad-info__val persian-number">{{ visits.outlet.code }}</span></span>
				</div>
				<div class="ad-info">
					<span class="ad-info__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 21V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v15"/><path d="M15 9h3a2 2 0 0 1 2 2v10"/><path d="M3 21h18"/></svg></span>
					<span class="ad-info__body"><span class="ad-info__lbl">شهر</span><span class="ad-info__val" v-if="visits.outlet.city">{{ visits.outlet.city.name }}</span></span>
				</div>
				<div class="ad-info">
					<span class="ad-info__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="3.4"/><path d="M4.5 20c0-3.3 3-5.5 7.5-5.5s7.5 2.2 7.5 5.5"/></svg></span>
					<span class="ad-info__body"><span class="ad-info__lbl">نیروی اجرایی</span><span class="ad-info__val" v-if="visits.promoter">{{ visits.promoter.first_name + ' ' + visits.promoter.last_name }}</span></span>
				</div>
				<div class="ad-info">
					<span class="ad-info__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/></svg></span>
					<span class="ad-info__body"><span class="ad-info__lbl">زمان ایجاد</span><span class="ad-info__val ad-info__val--date"><date-picker v-model="visits.start_datetime" type="datetime" format="YYYY-MM-DD HH:mm" display-format="jYYYY-jMM-jDD HH:mm" :timezone="true" :disabled="true" /></span></span>
				</div>
				<div class="ad-info" v-if="visits.has_due_date">
					<span class="ad-info__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg></span>
					<span class="ad-info__body"><span class="ad-info__lbl">زمان اجرا</span><span class="ad-info__val ad-info__val--date"><date-picker v-model="visits.due_date" type="date" format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD" :disabled="true" /></span></span>
				</div>
			</div>

			<div class="ad-feedback">
				<div class="ad-feedback__head">
					<span class="ad-feedback__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a8 8 0 0 1-11.5 7.2L4 21l1.9-5.4A8 8 0 1 1 21 12z"/></svg></span>
					<span class="ad-feedback__title">بازخورد</span>
					<span class="ad-user" v-if="modalName">{{ modalName }} {{ modalLastName }}</span>
				</div>
				<b-form-textarea
					id="textarea"
					v-model="commentData.visit_comment"
					placeholder="یادداشت یا بازخورد خود را بنویسید..."
					rows="3"
					max-rows="6"
					class="ad-textarea"
				></b-form-textarea>
				<div class="ad-feedback__actions">
					<button @click="acceptComment" class="ad-btn">ذخیره بازخورد</button>
				</div>
			</div>
		</div>
		<!-- ===== Answer categories (dynamic) ===== -->
		<div v-for="list in catList" :key="'cat' + list.id" class="ad-card ad-answers">
			<div class="ad-answers__head">
				<span class="ad-cat-icon">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="4" width="12" height="17" rx="2"/><path d="M9 4.5V3.5h6v1"/><path d="M9 12l1.6 1.6L14 10"/></svg>
				</span>
				<span class="ad-cat-title">{{ list.verbose_name }}</span>
			</div>
			<div class="ad-answers__body">
				<div class="ad-qa">
					<div v-for="answers in answerList" :key="answers.id">
						<div
							v-if="answers.question && answers.question.report_category && list.id === answers.question.report_category.id"
							class="ad-qa-item"
						>
							<div class="ad-q">
								<p class="ad-q__text">{{ answers.question.text }}</p>
								<p class="ad-q__short" v-if="answers.question.short_text">{{ answers.question.short_text }}</p>
							</div>
							<div class="ad-answer-wrap">
								<span class="ad-answer-label">پاسخ</span>
								<div class="ad-a" v-for="answerType in answers.question.answer_type" :key="answerType.id">
									<template v-if="answerType.name === 'YesNo'">
										<span class="ans-pill ans-pill--yes" v-if="answers.bool === true">بله</span>
										<span class="ans-pill ans-pill--no" v-else-if="answers.bool === false">خیر</span>
										<span class="ans-empty" v-else>ثبت نشده</span>
									</template>
									<template v-if="answerType.name === 'Triple'">
										<span class="ans-pill ans-pill--yes" v-if="answers.bool === true">بله</span>
										<span class="ans-pill ans-pill--no" v-else-if="answers.bool === false">خیر</span>
										<span class="ans-pill ans-pill--na" v-else>ندارد</span>
									</template>
									<div class="ans-score" v-if="answerType.name === 'Score'">
										<template v-if="answers.score">
											<span v-for="n in 5" :key="n" class="ans-score__star" :class="{ 'is-on': n <= answers.score }">★</span>
											<span class="ans-score__num persian-number">{{ answers.score }}</span>
										</template>
										<span class="ans-empty" v-else>ثبت نشده</span>
									</div>
									<span class="ans-value" v-if="answerType.name === 'Input'">{{ answers.text || '—' }}</span>
									<span class="ans-value" v-if="answerType.name === 'RadioChoice'">{{ (answers.radio && answers.radio.answer) || '—' }}</span>
									<span class="ans-value" v-if="answerType.name === 'DropDownList'">{{ (answers.dropdown && answers.dropdown.answer) || '—' }}</span>
									<template v-if="answerType.name === 'Description'">
										<div class="ans-desc-box" v-if="answers.description">{{ answers.description }}</div>
										<span class="ans-empty" v-else>بدون توضیح</span>
									</template>
									<template v-if="answerType.name === 'Multichoice'">
										<div class="ans-chips" v-if="answers.multichoice && answers.multichoice.length">
											<span class="ans-pill ans-pill--choice" v-for="multiAnswers in answers.multichoice" :key="multiAnswers.id">{{ multiAnswers.answer }}</span>
										</div>
										<span class="ans-empty" v-else>ثبت نشده</span>
									</template>
									<template v-if="answerType.name === 'Number'">
										<span class="ans-value ans-value--num persian-number" v-if="answers.number != null">{{ answers.number }}</span>
										<span class="ans-empty" v-else>ثبت نشده</span>
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="ad-qa-images">
					<div v-for="(image, index) in images" :key="'img' + image.id">
						<div
							v-if="image.type && image.type.report_category && list.id === image.type.report_category.id"
							class="ad-thumb"
						>
							<img @click="callModalimage(index)" :src="image.link" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="ad-card ad-photos">
			<div class="ad-answers__head">
				<span class="ad-cat-icon">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4.5" width="18" height="15" rx="2"/><circle cx="8.5" cy="10" r="1.8"/><path d="M4 18l5-5 3.5 3.5L16 13l4 4"/></svg>
				</span>
				<span class="ad-cat-title">تصاویر ثبت‌شده</span>
			</div>
			<Tableview
				:hover="true"
				:bordered="true"
				class="pb-2"
				:showNoContent="showContnetFunc"
				:showNoData="showDataFunc"
			>
				<template #TableTitle>
					<tr>
						<th>ردیف</th>
						<th>عنوان</th>
						<th>تصویر</th>
						<th>تاریخ</th>
						<th>لوکیشن</th>
					</tr>
				</template>

				<template #TableBody>
					<tr v-for="(item, index) in images" :key="item.id">
						<td class="persian-number">
							{{ 1 + index }}
						</td>
						<td>{{ item.type.verbose_name }}</td>
						<td>
							<img @click="callModalimage(index)" class="images" :src="item.link" />
						</td>
						<td>
							<date-picker
								v-model="item.datetime_created"
								type="datetime"
								format="YYYY-MM-DD HH:mm"
								display-format="jYYYY-jMM-jDD HH:mm"
								:timezone="true"
								:disabled="true"
							/>
						</td>
						<td>
							<span class="location" @click="showLocation(item)">مشاهده</span>
						</td>
					</tr>
				</template>
			</Tableview>
		</div>
		<b-modal hide-footer hide-header size="lg" centered v-model="imageModal">
			<b-carousel
					id="carousel-fade"
					style="text-shadow: 1px 1px 2px #333"
					v-if="images.length"
					controls
					indicators
					background="#ababab"
					fade
					v-model="carouselIndex"
					interval="120000"
				>
					<b-carousel-slide
						v-for="(image, index) in images"
						:key="index"
						:img-src="image.link"
					></b-carousel-slide>
				</b-carousel>
			<!-- <img class="modal-img" :src="imageUrl" /> -->
		</b-modal>
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';

export default {
	components: {
		Tableview,
	},
	data() {
		return {
			answerList: [],
			catList: [],
			visits: {},
			images: 0,
			imageModal: false,
			rejectReason: null,
			imageUrl: null,
			commentData: {},
			modalName: '',
			modalLastName: '',
			carouselIndex:0
		};
	},
	mounted() {
		this.getAnswerList();
		this.getImageList();
		this.getCategoryList();
		this.comment();
		this.getVisitDetails();
	},
	computed: {
		reasonBtn() {
			if (this.rejectReason === null || this.rejectReason.length === 0) {
				return true;
			} else {
				return false;
			}
		},
		showContnetFunc() {
			return this.images === 0;
		},
		showDataFunc() {
			if (this.images.length !== undefined) {
				return this.images.length === 0;
			}
			return false;
		},
	},
	methods: {
		async getVisitDetails() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.VISIT_DETAIL_EDIT +
					lastParam +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.visits = res.data;
			}
		},
		async getCategoryList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.REPORT_CAT_LIST +
					'?visit_id=' +
					lastParam +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&is_for_supervision=' +
					false,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.catList = res.data;
			}
		},
		callModalimage(index) {
			this.imageModal = true;
			this.carouselIndex = index;
			
			// this.imageUrl = item.link;
		},

		async getAnswerList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_VISIT_ANSWER_LIST +
					'?visit=' +
					lastParam +
					'&ordering=question__priority' +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&question__question_type__is_for_supervision=' +
					false +
					'&question__question_type__is_active=' +
					true,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.answerList = res.data;
				this.questions = res.data.question;
			}
		},
		async comment() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.ADD_COMMENT +
					lastParam +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.commentData = res.data;
				this.modalName = res.data.comment_publisher.first_name;
				this.modalLastName = res.data.comment_publisher.last_name;
			}
		},
		async acceptComment() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.put(
				this.$PATH.RELATIVE_PATH.MULTI.ADD_COMMENT + lastParam + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{
					visit_comment: this.commentData.visit_comment,
				},
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'بازخورد با موفقیت تغییر کرد!',
				});
			}
		},
		async getImageList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_PHOTO_LIST +
					'?visit=' +
					lastParam +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&type__is_for_supervision=' +
					false +
					'&type__report_category__is_for_supervision=' +
					false,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.images = res.data;
				'images:', res.data;
			}
		},
		showLocation(item) {
			window.open(`https://maps.google.com/?q=${item.latitude},${item.longitude}`, '_blank');
		},
	},
};
</script>
<style lang="scss" scoped>
.answer-list {
	padding: 4px 0 8px;
}

.ad-card {
	background: #fff;
	border: 1px solid #f3f8f8;
	border-radius: 16px;
	box-shadow: 0 10px 30px rgba(15, 26, 46, 0.05);
	padding: 22px 24px;
	margin-bottom: 20px;
}

/* ---- Header ---- */
.ad-header__top {
	display: flex;
	align-items: center;
	gap: 14px;
	margin-bottom: 20px;
}
.ad-store-icon {
	width: 52px;
	height: 52px;
	border-radius: 14px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #2d8b8b;
	background: rgba(45, 139, 139, 0.1);
	flex-shrink: 0;
	svg { width: 26px; height: 26px; }
}
.ad-header__title {
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;
	h2 { font-size: 20px; font-weight: 800; color: #1a2332; margin: 0; }
}
.ad-turn-badge {
	font-size: 12px;
	font-weight: 700;
	color: #2d8b8b;
	background: rgba(45, 139, 139, 0.1);
	padding: 4px 12px;
	border-radius: 999px;
}
.ad-info-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
	gap: 12px;
	margin-bottom: 22px;
}
.ad-info {
	display: flex;
	align-items: center;
	gap: 11px;
	background: #f6f9fd;
	border: 1px solid #f3f8f8;
	border-radius: 12px;
	padding: 10px 14px;
}
.ad-info__ic {
	width: 34px;
	height: 34px;
	border-radius: 9px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #2d8b8b;
	background: rgba(45, 139, 139, 0.09);
	flex-shrink: 0;
	svg { width: 18px; height: 18px; }
}
.ad-info__body { display: flex; flex-direction: column; min-width: 0; }
.ad-info__lbl { font-size: 11px; color: #8a97ad; font-weight: 600; margin-bottom: 1px; }
.ad-info__val {
	font-size: 14px;
	color: #1a2332;
	font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	font-family: 'IRANYekanfa';
}

/* ---- Feedback ---- */
.ad-feedback {
	border-top: 1px solid #f3f8f8;
	padding-top: 18px;
}
.ad-feedback__head {
	display: flex;
	align-items: center;
	gap: 9px;
	margin-bottom: 12px;
	.ad-feedback__ic { color: #2d8b8b; display: flex; svg { width: 18px; height: 18px; } }
	.ad-feedback__title { font-weight: 700; color: #1a2332; font-size: 15px; }
	.ad-user { margin-right: auto; font-size: 12px; color: #64748b; background: #f3f7fc; padding: 3px 12px; border-radius: 999px; }
}
.ad-textarea {
	border-radius: 12px !important;
	border: 1.5px solid #e7f2f3 !important;
	font-size: 14px;
}
.ad-feedback__actions { display: flex; justify-content: flex-end; margin-top: 12px; }
.ad-btn {
	background: linear-gradient(120deg, #3aa6a6, #2d8b8b 60%, #223047);
	color: #fff;
	border: none;
	border-radius: 10px;
	padding: 9px 26px;
	font-weight: 700;
	font-size: 14px;
	cursor: pointer;
	box-shadow: 0 8px 20px rgba(45, 139, 139, 0.28);
	transition: all 0.2s ease;
	&:hover { transform: translateY(-1px); filter: brightness(1.05); }
}

/* ---- Category / answers ---- */
.ad-answers__head {
	display: flex;
	align-items: center;
	gap: 11px;
	margin-bottom: 18px;
	padding-bottom: 14px;
	border-bottom: 1px solid #f3f8f8;
}
.ad-cat-icon {
	width: 38px;
	height: 38px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	background: linear-gradient(120deg, #3aa6a6, #2d8b8b);
	flex-shrink: 0;
	svg { width: 20px; height: 20px; }
}
.ad-cat-title { font-size: 17px; font-weight: 800; color: #1a2332; }
.ad-answers__body { display: flex; gap: 24px; align-items: flex-start; flex-wrap: wrap; }
.ad-qa { flex: 1 1 460px; min-width: 0; display: flex; flex-direction: column; gap: 12px; }
.ad-qa-item {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 16px;
	background: #f8fafd;
	border: 1px solid #f3f8f8;
	border-radius: 12px;
	padding: 14px 16px;
	flex-wrap: wrap;
	transition: border-color 0.16s ease;
	&:hover { border-color: #dbe7f8; }
}
.ad-q {
	min-width: 0;
	flex: 1 1 260px;
	.ad-q__text { font-size: 14px; font-weight: 600; color: #1f2b40; margin: 0 0 4px; line-height: 1.75; }
	.ad-q__short { font-size: 12px; color: #9aa6bb; margin: 0; }
}
.ad-answer-wrap {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 6px;
	flex-shrink: 0;
}
.ad-answer-label {
	font-size: 10.5px;
	font-weight: 700;
	letter-spacing: 1px;
	color: #9aa6bb;
}
.ad-a { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; flex-shrink: 0; }

/* answer types */
.ans-pill {
	display: inline-flex;
	align-items: center;
	padding: 6px 16px;
	border-radius: 999px;
	font-size: 13px;
	font-weight: 700;
	white-space: nowrap;
}
.ans-pill--yes { background: rgba(16, 185, 129, 0.13); color: #0b7a5b; }
.ans-pill--no { background: rgba(239, 77, 106, 0.13); color: #c02a45; }
.ans-pill--na { background: #f3f8f8; color: #64748b; }
.ans-pill--choice { background: rgba(45, 139, 139, 0.1); color: #277b7b; }
.ans-value {
	display: inline-flex;
	align-items: center;
	padding: 7px 16px;
	border-radius: 10px;
	background: #eef3fb;
	color: #1a2332;
	font-size: 13px;
	font-weight: 600;
	border: 1px solid #e0e9f6;
	max-width: 320px;
}
.ans-value--num {
	font-family: 'IRANYekanfa' !important;
	background: rgba(45, 139, 139, 0.1);
	border-color: rgba(45, 139, 139, 0.22);
	color: #277b7b;
	font-weight: 700;
	min-width: 46px;
	justify-content: center;
}
.ans-chips { display: flex; flex-wrap: wrap; gap: 6px; justify-content: flex-end; }
.ans-desc-box {
	min-width: 260px;
	max-width: 440px;
	border: 1px solid #e7f2f3;
	border-radius: 12px;
	background: #fff;
	padding: 10px 14px;
	font-size: 13px;
	color: #5c6b78;
	line-height: 1.85;
	white-space: pre-wrap;
	word-break: break-word;
	text-align: right;
}
.ans-empty {
	display: inline-flex;
	align-items: center;
	font-size: 13px;
	color: #aeb8c9;
	padding: 6px 4px;
}
.ans-score {
	display: inline-flex;
	align-items: center;
	gap: 2px;
	.ans-score__star { font-size: 19px; color: #dbe2ee; line-height: 1; }
	.ans-score__star.is-on { color: #f59e0b; }
	.ans-score__num { margin-right: 8px; font-size: 13px; font-weight: 700; color: #f59e0b; font-family: 'IRANYekanfa' !important; }
}

/* category images */
.ad-qa-images {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	align-content: flex-start;
	flex: 0 1 auto;
	max-width: 44%;
}
.ad-thumb img {
	width: 92px;
	height: 92px;
	object-fit: cover;
	border-radius: 12px;
	border: 1px solid #e7f2f3;
	cursor: pointer;
	transition: all 0.2s ease;
	&:hover { transform: scale(1.04); box-shadow: 0 10px 24px rgba(45, 139, 139, 0.22); }
}

/* photos table */
.ad-photos .images {
	width: 56px;
	height: 56px;
	object-fit: cover;
	border-radius: 8px;
	cursor: pointer;
}
.ad-photos .location {
	color: #2d8b8b !important;
	cursor: pointer;
	font-weight: 600;
}

.persian-number { font-family: 'IRANYekanfa' !important; }

@media (max-width: 900px) {
	.ad-answers__body { flex-direction: column; }
	.ad-qa-images { max-width: 100%; }
	.ad-qa { flex: 1 1 100%; }
}
</style>

<style>
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input {
	border: none !important;
	border-radius: 0;
	font-family: 'IRANYekanfa';
}
.vpd-input-group input:disabled {
	background: #fff;
	text-align: center;
	min-width: 130px;
}
</style>
